module.exports = __webpack_public_path__ + "img/noCard.3c21f931.png";